import { useEffect, useState } from 'react';
import { appleMapsUrl, googleMapsUrl, isAppleDevice, mapsQuery } from '~/lib/maps';

/**
 * Directions control — offers BOTH Apple Maps and Google Maps for an address.
 * The device hint (resolved after mount to stay SSR-safe) just reorders which
 * comes first; both links always render.
 */
export function Directions({
  locationName,
  address,
  size = 'sm',
}: {
  locationName: string;
  address: string;
  size?: 'sm' | 'md';
}) {
  const q = mapsQuery(locationName, address);
  const [apple, setApple] = useState(false);
  useEffect(() => setApple(isAppleDevice()), []);
  if (!q) return null;

  const appleLink = (
    <a
      key="apple"
      href={appleMapsUrl(q)}
      target="_blank"
      rel="noopener noreferrer"
      className={`ui-btn btn-secondary ${size === 'sm' ? 'btn-sm' : ''}`}
    >
      Apple Maps
    </a>
  );
  const googleLink = (
    <a
      key="google"
      href={googleMapsUrl(q)}
      target="_blank"
      rel="noopener noreferrer"
      className={`ui-btn btn-secondary ${size === 'sm' ? 'btn-sm' : ''}`}
    >
      Google Maps
    </a>
  );

  return (
    <div className="row directions-row" aria-label={`Directions to ${q}`}>
      {apple ? [appleLink, googleLink] : [googleLink, appleLink]}
    </div>
  );
}
